import { FC, ReactNode } from 'react';
import { KioskHomeContextProps } from './kiosk-home.context';
import KioskHomeMain from './kiosk-home.main';

interface KioskHomeWrapperProps extends KioskHomeContextProps {
  children: ReactNode;
}

export const KioskHomeWrapper: FC<KioskHomeWrapperProps> = ({ children, ...contextProps }) => {
  return <KioskHomeMain {...contextProps}>{children}</KioskHomeMain>;
};
